import { resolveTenantApiUrl } from '../../shared/api/resolveApiUrl.js';
import {
  customerEnvelopeApiError,
  customerInvalidJsonApiError,
} from '../../shared/errors/customerApiParseErrors.js';
import { stormAwareFetch } from '../../shared/http/stormAwareFetch.js';

/** TENANT ops mode from pickup-slots (P3 pause/delay UX). */
export type TenantOpsMode = 'NORMAL' | 'DELAY' | 'PAUSE';
/** @deprecated Prefer {@link TenantOpsMode}. */
export type TenantPickupOpsMode = TenantOpsMode;

export interface PickupSlotsResult {
  readonly slots: Array<{ startAt: string; endAt: string; available: boolean }>;
  readonly opsMode: TenantOpsMode;
  readonly opsBufferMs: number | null;
}

function parseOpsMode(value: unknown): TenantOpsMode {
  if (value === 'DELAY' || value === 'PAUSE' || value === 'NORMAL') {
    return value;
  }
  return 'NORMAL';
}

function parseOpsBufferMs(value: unknown): number | null {
  if (typeof value === 'number' && Number.isFinite(value) && value > 0) {
    return value;
  }
  return null;
}

export async function fetchPickupSlots(params: {
  tenantCode: string;
  kioskId: number;
  pickupPointId: number;
  from: string;
  to: string;
}): Promise<PickupSlotsResult> {
  const url = resolveTenantApiUrl('', params.tenantCode, '/customer-checkout/pickup-slots', {
    salesPointId: params.kioskId,
    pickupPointId: params.pickupPointId,
    from: params.from,
    to: params.to,
  });
  const response = await stormAwareFetch(url, {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });
  let json: {
    success: boolean;
    data?: {
      slots: Array<{ startAt: string; endAt: string; available: boolean }>;
      opsMode?: unknown;
      opsBufferMs?: unknown;
    };
    error?: string;
  };
  try {
    json = (await response.json()) as typeof json;
  } catch {
    throw customerInvalidJsonApiError(response.status);
  }
  if (!response.ok || !json.success || !json.data) {
    throw customerEnvelopeApiError(response.status, json);
  }
  return {
    slots: json.data.slots,
    opsMode: parseOpsMode(json.data.opsMode),
    opsBufferMs: parseOpsBufferMs(json.data.opsBufferMs),
  };
}
